import React, { useState } from "react";
import toast from "react-hot-toast";
import "./ImportModal.scss";

const ImportModal = ({
  show,
  onClose,
  onImport,
  defaultFrequency = "weekly",
  defaultBatchSize = 5,
  defaultStartDate = "",
}) => {
  const [importFile, setImportFile] = useState(null);
  const [frequency, setFrequency] = useState(defaultFrequency);
  const [batchSize, setBatchSize] = useState(defaultBatchSize);
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [surveyTitle, setSurveyTitle] = useState(""); // New state for title

  if (!show) return null;

  const handleImport = async () => {
    if (!importFile) {
      toast.error("Please select a file first.");
      return;
    }

    if (!surveyTitle.trim()) {
      toast.error("Please enter a survey title.");
      return;
    }

    const formData = new FormData();
    formData.append("file", importFile);
    formData.append("frequency", frequency);
    formData.append("batchSize", batchSize);
    formData.append("startDate", startDate);
    formData.append("surveyTitle", surveyTitle); // Include title in formData

    try {
      await onImport(formData);
      toast.success("Questions imported successfully!");
      onClose();
    } catch (err) {
      toast.error("Import failed!");
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-card">
        <h3>Import Questions</h3>

        <label>Title:</label>
        <input
          type="text"
          value={surveyTitle}
          onChange={(e) => setSurveyTitle(e.target.value)}
          placeholder="Enter Title"
          className="title-input"
        />

        <input
          type="file"
          accept=".csv,.xlsx,.json"
          onChange={(e) => setImportFile(e.target.files[0])}
        />

        <label>Frequency:</label>
        <select
          value={frequency}
          onChange={(e) => setFrequency(e.target.value)}
        >
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </select>

        <label>Batch Size:</label>
        <input
          type="number"
          min="1"
          value={batchSize}
          onChange={(e) => setBatchSize(Number(e.target.value))}
        />

        <label>Start Date:</label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />

        <div className="modal-actions">
          <button onClick={onClose}>Cancel</button>
          <button onClick={handleImport}>Import</button>
        </div>
      </div>
    </div>
  );
};

export default ImportModal;
